export default __webpack_public_path__ + "static/media/GroundsImg.42b3f379.jpg";